const fullgrid = {
    numColumns: 2,
    numRows: 1,
    // used for view more feature, view more starts on this slide
    slidesCovered: 2,
    moreSize: 12,
    borderWidth: 15,
    extraRows: 0,
    cellInstances: null,
    cells: {
        // image order as returned are keys
        1: {
            imageNum:0,
            col: 0,
            row: 0,
            size: 1,
        },
        2: {
            imageNum: 1,
            col: 1,
            row: 0,
            size: 1,
        },
    }
}

export default fullgrid;
